import React from 'react'
import InputSelect from '../InputSelect'

const DisciplinesFromClassInputSelect = ({
    clss,
    name,
    placeholder = 'Selecione uma disciplina...',
    ...rest
}) => {
    return (
        <InputSelect disabled={!clss?.disciplinas?.length}
            name={name} options={clss?.disciplinas}
            label='Disciplina'
            placeholder={placeholder}
            getOptionLabel={(option) => (
                option.nome
            )}
            getOptionValue={(option) => (
                option.id
            )}
            {...rest}
        />
    )
}

export default DisciplinesFromClassInputSelect
